import React, { Component } from 'react';

export default class Accordeon extends Component {

    render() {
        return (
            <li>
                <div className={`collapsible-header ${this.props.active ? "active" : ""}`} >
                    <i className="material-icons white-text down-icon">keyboard_arrow_down</i>
                    <i className="material-icons white-text up-icon">keyboard_arrow_up</i>
                    {this.props.name}
                    {this.props.secondary_text &&
                    <div style={{float: 'right'}} className={'right'}>{this.props.secondary_text}</div>
                    }
                </div>
                <div className={`collapsible-body ${this.props.bordered ? 'collapsible-bordered' : '' }`}>{this.props.children}</div>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Accordeon/accordeon.js